<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientFirstName"
            :rules="nameRules"
            :counter="30"
            label="Voornaam*"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientPrefixName"
            :rules="middleNameRules"
            :counter="10"
            label="Tussenvoegsel"
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientLastName"
            :rules="nameRules"
            :counter="30"
            label="Achternaam*"
            required
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-select
            label="Geboortedatum*"
            :items="days"
            :rules="dateRules"
            v-model="contactFormModel.clientBirthDay"
            required
            outlined
            type="number"
            min="1"
            max="31"
          >
          </v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            label="Maand*"
            :items="months"
            :rules="dateRules"
            v-model="selectedMonth"
            required
            @change="onChange($event)"
            outlined
            type="number"
            min="1"
            max="12"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            label="Jaar*"
            :items="years"
            :rules="dateRules"
            v-model="contactFormModel.clientBirthYear"
            required
            @change="onChange($event)"
            outlined
            type="number"
            min="1911"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientZipCode"
            :rules="postCodeRules"
            :counter="8"
            label="Postcode*"
            required
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientHuisnummer"
            :rules="houseNumberRules"
            :counter="10"
            label="Huisnummer*"
            required
            outlined
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            v-model="contactFormModel.clientHuisnummerToevoeging"
            :rules="additionalInfoRules"
            :counter="10"
            label="Toevoeging"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="contactFormModel.clientEmail"
            :rules="emailRules"
            :counter="50"
            label="E-mailadres*"
            required
            outlined
            type="email"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="contactFormModel.clientPhone"
            :rules="telephoneNumberRules"
            :counter="20"
            label="Telefoonnummer*"
            required
            outlined
            type="phone"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-checkbox
            v-model="contactFormModel.sendEmail"
            :rules="[(v) => !!v || 'U moet akkoord gaan om door te gaan!']"
            label="Hierbij geef ik toestemming voor gebruik van de n.a.w. gegevens t.b.v. het inplannen van de afspraak.*"
            required
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row> </v-row>
    </v-container>
  </v-form>
</template>
<script>
    /* eslint-disable */
    import { mapState, mapActions } from "vuex";
    import * as moment from "moment";

    export default {
        props: {
            formModel: Object,
        },
        data: () => ({
            valid: false,
            contactFormModel: {
                clientFirstName: "",
                clientPrefixName: "",
                clientLastName: "",
                clientBirthDay: 0,
                clientBirthMonth: 0,
                clientBirthYear: 0,
                clientZipCode: "",
                clientHuisnummer: "",
                clientHuisnummerToevoeging: "",
                clientEmail: "",
                clientPhone: "",
                sendEmail: "",
                dataPermission: false,
            },
            nameRules: [
                (v) => !!v || "Naam is vereist",
                (v) => v.length <= 30 || "Naam mag niet langer zijn dan 30 tekens",
            ],
            middleNameRules: [
                (v) => v.length <= 10 || "Tussenvoegsel mag niet langer zijn dan 10 tekens",
            ],
            postCodeRules: [
                (v) => !!v || "Postcode is verplicht",
                (v) => v.length <= 8 || "Postcode mag niet langer zijn dan 8 tekens",
                (v) => /^(?:\d{4}\s{0,1}[a-zA-Z]{2}|DE[\s-]{0,1}\d{5}|BE[\s-]{0,1}\d{4})$/gis.test(v) || "Een Nederlandse postcode moet 4 cijfers en 2 letters bevatten. Duitse en Belgische postcodes kunnen opgeven worden met respectievelijk DE- of BE- voorvoegsel.",
            ],
            houseNumberRules: [
                (v) => !!v || "Huisnummer is verplicht",
                (v) => v.length <= 10 || "Huisnummer mag niet langer zijn dan 10 tekens",
                (v) => Number.isInteger(Number(v)) || "De waarde moet een getal zijn",
            ],
            additionalInfoRules: [
                (v) => v.length <= 10 || "Toevoeging mag niet langer zijn dan 10 tekens",
            ],
            emailRules: [
                (v) => !!v || "E-mail is verplicht",
                (v) => v.length <= 50 || "E-mail mag niet langer zijn dan 50 tekens",
                (v) => /^(?:[a-zA-Z0-9_\-\.]+)(?:\+[a-zA-Z0-9_\-\.]+)?@(?:(?:(?:[a-zA-Z0-9\-]+\.)+))(?:[a-zA-Z]{2,16})$/gis.test(v) || "E-mailadres moet geldig zijn.",
            ],
            telephoneNumberRules: [
                (v) => !!v || "Telefoonnummer is verplicht",
                (v) => v.length <= 20 || "Telefoonnummer mag niet langer zijn dan 20 tekens",
                (v) => v.length >= 5 || "Telefoonnummer mag niet korter zijn dan 5 tekens",
                (v) => /^(?:\+\s?)?(?:\(\+?\d+(?:[\s\-\.]?\d+)?\)|\d+)(?:[\s\-\.]?(?:\(\d+(?:[\s\-\.]?\d+)?\)|\d+))*(?:\s?(?:x|ext\.?)\s?\d+)?$/gis.test(v) || "Telefoonnummer moet geldig zijn.",
            ],
            years: [],
            months: [],
            days: [],
            dateRules: [(v) => !!v || "Datum is verplicht"],
            daysInMonths: "",
            selectedYear: "",
            selectedMonth: "",
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
            formValid: function () {
                return this.valid;
            },
        },
        mounted: function () {
            this.years = this.getYears();
            this.months = this.getMonths();
            this.days = this.initialDays();
        },
        methods: {
            ...mapActions({
                updateFormModel: "appBar/updateFormModel",
            }),
            getYears() {
                var currentYear = new Date().getFullYear();
                var allYears = [];
                var startYear = 1911;

                for (var i = currentYear; i >= startYear; i--) {
                    allYears.push(i);
                }

                return allYears;
            },
            getMonths() {
                moment.locale("nl");

                return moment.months();
            },
            initialDays() {
                var allDays = [];
                var x = 1;
                while (x <= 31) {
                    allDays.push(x++);
                }

                return allDays;
            },
            onChange(event) {
                moment.locale("nl");

                if (
                    this.selectedMonth != "" &&
                    this.contactFormModel.clientBirthYear !== ""
                ) {
                    var dayCount = new Date(
                        this.contactFormModel.clientBirthYear,
                        moment().month(this.selectedMonth).format("M"),
                        0
                    ).getDate();
                    var x = 1;
                    this.days = [];

                    while (x <= dayCount) {
                        this.days.push(x++);
                    }
                }
            },
        },
        watch: {
            formValid: function (value) {
                moment.locale("nl");
                var num = Number(moment().month(this.selectedMonth).format("M"));
                this.contactFormModel.clientBirthMonth = num;
                this.contactFormModel.dataPermission = this.valid;
                this.updateFormModel({
                    formModel: {
                        id: 5,
                        title: "",
                        ...this.contactFormModel,
                        selected: true,
                    },
                });
            },
        },
    };
</script>